import styles from "./Bonuses.module.css"
import { useContext, useEffect, useState } from "react";
import { Card, ConfigProvider, Progress, Tooltip } from "antd";

import formatCurrency from "../../Utils/formatCurrency";
import Modal from "../Modals/Modal";
import Choice from "../Modals/components/Choice/Choice";
import ServiceBonuses from "./Service/Service"
import { Context } from "../../index";
import Spin from "../UI/Spin/Spin";
import ErrorComponent from "../UI/Error/ErrorComponent";
import { NAME_SERVER } from "../../Utils/NAME_HOST";
import SuccsesFreeSpins from "../Modals/components/SuccsesFreeSpins/SuccsesFreeSpins";
import Succses from "../UI/Notification/Succses"
import UserService from "../../service/UserService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Promocode from "../Modals/components/Promocode/Promocode";

function Bonuses() {
    const { store } = useContext(Context)
    const [stateModal, setStateModal] = useState(false)
    const [modal_succses, setModalSuccses] = useState({ status: false, text: "" })
    const [bonus_id_active, setBonus_id_active] = useState([])
    const [modal_promocode, setModal_promocode] = useState(false)
    const [current_type_promocode, setCurrent_type_promocode] = useState("")
    const [type_bonus_active, setType_bonus_active] = useState(null)
    const [cards, setCards] = useState([])
    const [loading, setLoading] = useState(true);
    const img1 = NAME_SERVER + "/assets/" + "snake_pic1.png"
    const img2 = NAME_SERVER + "/assets/" + "snake_pic2.png"


    async function handleClick(type) {
        try {

            console.log(type, "type")
            const bonus_id = bonus_id_active[0]
            const action = bonus_id_active[1]

            const response = await ServiceBonuses.activate_bonus(store.user.id, bonus_id, action)
            const data = response.data
            if (data.status === "ok") {
                if (type === "reg") {
                    const response = await UserService.UsePromocode(null, { type: "getFreespins", bonus_id })
                    const data = response.data;
                    if (data.status === 1) {
                        store.add_message("Бонус успешно активирован", Succses)
                        await start()

                    }
                    else {
                        store.add_message(data.err, ErrorComponent)

                    }


                }
                else {
                    await start()
                }


            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)
        } finally {
            setStateModal(false)
        }


    }

    async function cancelBonus() {
        const response = await ServiceBonuses.cancelBonus(store.user.id)
        const data = response.data



        await start()

    }
    async function getBonusClick(bonus_id, action, amount) {
        const response = await ServiceBonuses.getBonus(store.user.id, bonus_id, action)
        const data = response.data
        if (data.status === "ok") {

            setModalSuccses({ status: true, text: "Вы получили " + formatCurrency(amount, "cost") })
            const responseBalance = await UserService.getBalance()

            if (responseBalance.data.status === 1) {
                store.user.balance = responseBalance.data.balance;
                store.user.balance_casino = responseBalance.data.balance_bonus
            }
            await start()
        }
    }

    function handleClose() {
        setStateModal(false)
    }


    async function start() {
        setLoading(true)



        const resp = await ServiceBonuses.getListBonuses(store.user.id);
        if (resp.status === 200) {
            const data = resp.data;
            const mass_result = []
            for (const key of Object.keys(data)) {
                const card_data = data[key]
                let variant = "dep"
                mass_result.push({
                    id: key,
                    status: card_data[variant].status,
                    name: card_data[variant].bonus_name,
                    aim: card_data[variant].aim,
                    min_amount: card_data[variant].min_amount,
                    progress: card_data[variant].progress,

                    wager: card_data[variant].wager,
                    max_bonus: card_data.max_bonus,

                    date_end: card_data.date_until,
                    currency: card_data.currency,
                    variant
                })
                variant = "reg"
                mass_result.push({
                    id: key,
                    status: card_data[variant].status,
                    name: card_data[variant].bonus_name,
                    aim: card_data[variant].aim,
                    min_amount: card_data[variant].min_amount,
                    free_spins: card_data[variant].free_spins,
                    free_spins_total_win: card_data[variant].free_spins_total_win,
                    free_spins_left: card_data[variant].free_spins_left,

                    progress: card_data[variant].progress,

                    wager: card_data[variant].wager,
                    max_bonus: card_data.max_bonus,
                    date_end: card_data.date_until,
                    currency: card_data.currency,
                    variant

                })

            }
            const response = await UserService.getBalance()
            if (response.data.status === 1) {
                store.user.balance = response.data.balance;
                store.user.freespins = response.data.freespin
                store.user.balance_casino = response.data.balance_bonus
            }
            mass_result.sort(function (a, b) {
                return (a.status === "6" || a.status === "4") ? -999 : a.status - b.status
            })
            setCards(mass_result)
            setLoading(false)

        }



    }

    useEffect(() => {
        start()
    }, []);
    if (loading) {
        return <Spin />
    }
    return (
        <div className={styles.main}>
            <Modal props={{
                handleClick,
                handleClose,
                type: type_bonus_active,
                text: "При активации нового бонуса сгорает действующий активный бонус (если такой есть)"
            }} ModelState={stateModal} setModelState={setStateModal}
                Component={Choice} type={"choice"} />
            <Modal props={{
                disableNavigate: true, text: modal_succses.text, closeModel: () => {
                    setModalSuccses({ status: false, text: "" })
                }
            }} Component={SuccsesFreeSpins}
                ModelState={modal_succses.status} setModelState={() => setModalSuccses({ status: false, text: "" })} />
            <Modal Component={Promocode} props={{ closeModal: () => { console.log("close"); setModal_promocode(false) }, handleOk: start, current_type_promocode }} setModelState={setModal_promocode} ModelState={modal_promocode} />
            <div className={styles.noBonus}>
                {cards.length === 0 && <div>{store.dataLang["no_bonuses_text"]}</div>}
                <div style={{display:"flex",gap:"10px"}}>

                
                <button onClick={() => { setCurrent_type_promocode("vaucher"); setModal_promocode(true) }} style={{ backgroundColor: "green" }}>Ввести ваучер<i class="fa-solid fa-money-bill-wave"></i></button>
                <button onClick={() => { setCurrent_type_promocode("promocode"); setModal_promocode(true) }} style={{ backgroundColor: "rgba(229, 197, 12, 0.77)" }}>{store.dataLang["enter_promocode_name"]} <i class="fa-solid fa-gift"></i></button>
                </div>
            </div>
            <div className={styles.cardContainer}>


                {cards.map(card => {

                    if (card.variant === "reg") {
                        if (card.status === "3") {
                            return (<Card
                                style={{
                                    width: "100%",
                                    maxWidth: "350px",
                                    background: "black",
                                    border: "none",
                                }}
                                cover={
                                    <img
                                        alt=""
                                        src={img1}
                                    />
                                }

                            >
                                <div className={styles.content}>
                                    <div className={styles.header}>
                                        {card.name}
                                    </div>
                                    <div className={styles.description}>
                                        <div style={{ color: "gray", fontSize: "14px" }}>Вейджер x{card.wager}</div>

                                        <div style={{ color: "gray", fontSize: "14px" }}>Максимальный бонус {card.max_bonus} {card.currency}</div>


                                        <div style={{
                                            color: "gray",
                                            fontSize: "14px"
                                        }}>Истекает {card.date_end.split(" ")[1].substring(0, 5)} {card.date_end.split(" ")[0].split("-").reverse().join(".")}</div>


                                    </div>

                                    <button style={{ marginTop: "20px", background: "#e5c50cc4" }}
                                        className={`wallet_nav_bar skeleton-button`} onClick={() => {
                                            setType_bonus_active("reg")
                                            setStateModal(true);

                                            setBonus_id_active([card.id, "reg"])
                                        }}>Активировать
                                    </button>



                                </div>
                            </Card>);

                        }
                        if (card.status === "1" || card.status === "4" || card.status === "6") {
                            return (<Card
                                style={{
                                    width: "100%",
                                    maxWidth: "350px",
                                    background: "black",
                                    border: "none",
                                }}
                                cover={
                                    <img
                                        alt=""
                                        src={img1}
                                    />
                                }

                            >

                                <div className={`${styles.activeCard} ${styles.positionLeft}`}>Бонус активен</div>
                                <div className={styles.positionRight}>
                                    <Tooltip zIndex={2} align={{ offset: [-8, 5] }} placement="bottom"
                                        title={"Оборот считается во всех доступных слотах и лайве, а также в наших играх - Wheel , Ставки на змеек, Саппер"}>
                                        <i className="fa-solid fa-circle-info"
                                            style={{ color: "#74c0fc", fontSize: "20px", cursor: "pointer" }}></i>
                                    </Tooltip></div>


                                <div className={styles.content}>

                                    <div className={styles.header} dangerouslySetInnerHTML={{ __html: card.name }}></div>
                                    <div className={styles.description}>
                                        <div style={{ color: "gray", fontSize: "14px" }}>Вейджер x{card.wager}</div>
                                        <div style={{ color: "gray", fontSize: "14px" }}>Максимальный бонус {card.max_bonus} {card.currency}</div>

                                        <div style={{
                                            color: "gray",
                                            fontSize: "14px"
                                        }}>Истекает {card.date_end.split(" ")[1].substring(0, 5)} {card.date_end.split(" ")[0].split("-").reverse().join(".")}</div>
                                        {card.free_spins_left === 0 ? (
                                            <div style={{ color: "green" }}>Вы
                                                выиграли {formatCurrency(card.free_spins_total_win, "cost")}</div>

                                        ) : (
                                            <div style={{ color: "green" }}>Осталось {card.free_spins_left} FS</div>

                                        )}

                                        {card.aim > 0 && (
                                            <div>
                                                {formatCurrency(card.progress, "cost")} / {formatCurrency(card.aim, "cost")}
                                            </div>

                                        )}


                                    </div>
                                    {(card.aim > 0 && card.status !== "4") && (
                                        <div style={{ marginTop: "10px", color: "greenyellow", fontSize: "30px" }}>
                                            <ConfigProvider theme={{
                                                token: { colorText: "white" }

                                            }}>
                                                <Progress strokeColor={"#2fec36"} style={{ color: "green" }}
                                                    trailColor={"#293069"}
                                                    type={"circle"}
                                                    percent={(card.progress / card.aim * 100).toFixed(2)} />

                                            </ConfigProvider>

                                        </div>
                                    )}
                                    {card.aim === 0 && (
                                        <div style={{ marginTop: "10px", textAlign: "center" }}>
                                            Чтобы начать отыгрывать бонус, потратьте все фриспины.
                                        </div>
                                    )}


                                    {card.status === "4" ? (
                                        <button style={{ marginTop: "20px" }}
                                            onClick={async () => getBonusClick(card.id, "reg", card.aim / card.wager)}
                                            className={`wallet_nav_bar skeleton-button`}>Забрать бонус</button>
                                    ) : <button style={{ marginTop: "20px" }}
                                        onClick={async () => cancelBonus()}
                                        className={`wallet_nav_bar skeleton-button ` + styles.cancel}>Отменить бонус</button>}


                                    {/*<button style={{marginTop: "30px"}}*/}
                                    {/*        className={`wallet_nav_bar skeleton-button`}>Активировать*/}
                                    {/*</button>*/}
                                </div>

                            </Card>);
                        }
                    }
                    if (card.variant === "dep") {
                        if (card.status === "2" || card.status === "3") {
                            return (<Card
                                style={{
                                    width: "100%",
                                    maxWidth: "350px",
                                    background: "black",
                                    border: "none",
                                }}
                                cover={
                                    <img
                                        alt=""
                                        src={img2}
                                    />
                                }

                            >
                                <div className={styles.content}>
                                    <div className={styles.header}>
                                        {card.name}
                                    </div>
                                    <div className={styles.description}>
                                        <div style={{ color: "gray", fontSize: "14px" }}>Вейджер x{card.wager}</div>
                                        <div style={{ color: "gray", fontSize: "14px" }}>Минимальный
                                            депозит {card.min_amount} {card.currency}</div>
                                        <div style={{ color: "gray", fontSize: "14px" }}>Максимальный бонус {card.max_bonus} {card.currency}</div>


                                        <div style={{
                                            color: "gray",
                                            fontSize: "14px"
                                        }}>Истекает {card.date_end.split(" ")[1].substring(0, 5)} {card.date_end.split(" ")[0].split("-").reverse().join(".")}</div>


                                    </div>
                                    {card.status === "2" ? (
                                        <a style={{ marginTop: "20px" }} className="wallet_nav_bar skeleton-button"
                                            href="/pay"><span>Пополнить</span></a>

                                    ) : (
                                        <button style={{ marginTop: "20px", background: "#e5c50cc4" }}
                                            className={`wallet_nav_bar skeleton-button`} onClick={() => {
                                                setType_bonus_active("dep")
                                                setStateModal(true);


                                                setBonus_id_active([card.id, "dep"])
                                            }}>Активировать
                                        </button>
                                    )}


                                </div>
                            </Card>);

                        }
                        if (card.status === "1" || card.status === "4") {
                            return (
                                <Card
                                    style={{
                                        width: "100%",
                                        maxWidth: "350px",
                                        background: "black",
                                        border: "none",
                                    }}
                                    cover={
                                        <img
                                            alt=""
                                            src={img2}
                                        />
                                    }

                                >
                                    <div className={styles.activeCardLeft}>Бонус активен</div>

                                    <div className={styles.content}>
                                        <div className={styles.header}>
                                            {card.name}
                                        </div>
                                        <div className={styles.description}>
                                            <div style={{ color: "gray", fontSize: "14px" }}>Вейджер x{card.wager}</div>
                                            <div style={{ color: "gray", fontSize: "14px" }}>Минимальный
                                                депозит {card.min_amount} {card.currency}</div>
                                            <div style={{ color: "gray", fontSize: "14px" }}>Максимальный бонус {card.max_bonus} {card.currency}</div>


                                            <div style={{
                                                color: "gray",
                                                fontSize: "14px"
                                            }}>Истекает {card.date_end.split(" ")[1].substring(0, 5)} {card.date_end.split(" ")[0].split("-").reverse().join(".")}</div>
                                            <div style={{ color: "greenyellow" }}>Вы
                                                получите {formatCurrency(card.aim / card.wager, "cost")}</div>
                                            {card.aim > 0 && (
                                                <div>
                                                    {formatCurrency(card.progress, "cost")} / {formatCurrency(card.aim, "cost")}
                                                </div>

                                            )}


                                        </div>
                                        {(card.aim > 0 && card.status !== "4") && (
                                            <div style={{ marginTop: "10px", color: "greenyellow", fontSize: "30px" }}>
                                                <ConfigProvider theme={{
                                                    token: { colorText: "white" }

                                                }}>
                                                    <Progress strokeColor={"#2fec36"} style={{ color: "green" }}
                                                        trailColor={"#293069"}
                                                        type={"circle"}
                                                        percent={(card.progress / card.aim * 100).toFixed(2)} />

                                                </ConfigProvider>

                                            </div>
                                        )}
                                        {card.status === "4" ? (
                                            <button style={{ marginTop: "20px" }}
                                                onClick={async () => getBonusClick(card.id, "dep", card.aim / card.wager)}
                                                className={`wallet_nav_bar skeleton-button`}>Забрать бонус</button>
                                        ) : <button style={{ marginTop: "20px" }}
                                            onClick={async () => cancelBonus()}
                                            className={`wallet_nav_bar skeleton-button` + styles.cancel}>Отменить бонус</button>}


                                    </div>
                                </Card>
                            )
                        }
                    }

                    return null; // Необходимо возвращать null, если ни одно условие не выполнено
                })}
            </div>



        </div>
    )

}

export default Bonuses